import { render, staticRenderFns } from "./AssetGroupBookingDetails.vue?vue&type=template&id=244551da"
import script from "./AssetGroupBookingDetails.vue?vue&type=script&lang=js"
export * from "./AssetGroupBookingDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports